import React from "react"
import { useSelector } from "react-redux"
import { accessibleTasks, tracked as trackedSelector } from "reduxSlices/formSubmissionSlice"
import { conversations as conversationsSelector } from "reduxSlices/formSubmissionConversationsSlice"
import { SidebarCollapsibleContent } from "shared/Sidebar"
import ShowFormSubmissionAuditsCheckbox from "./ShowFormSubmissionAuditsCheckbox"
import ShowResolutionAuditsCheckbox from "./ShowResolutionAuditsCheckbox"
import ShowTaskAuditsCheckbox from "./ShowTaskAuditsCheckbox"
import ShowConversationAuditsCheckbox from "./ShowConversationAuditsCheckbox"

const AuditableFilters = () => {
  const tasks = useSelector(accessibleTasks)
  const conversations = useSelector(conversationsSelector)
  const tracked = useSelector(trackedSelector)

  return (
    <>
      <SidebarCollapsibleContent title="Filter By Item">
        <div role="group" aria-label="Filter by item">
          <ShowFormSubmissionAuditsCheckbox />
        </div>
      </SidebarCollapsibleContent>

      {
        tasks.length > 0
        && (
          <>
            <SidebarCollapsibleContent title="Filter By Task">
              <div className="flex flex-col gap-2">
                {tasks.map((task) => (
                  <ShowTaskAuditsCheckbox key={task.id} task={task} />
                ))}
              </div>
            </SidebarCollapsibleContent>
          </>
        )
      }

      {
        conversations.length > 0
        && (
          <>
            <SidebarCollapsibleContent title="Filter By Conversation">
              <div className="flex flex-col gap-2">
                {conversations.map((conversation) => (
                  <ShowConversationAuditsCheckbox key={conversation.id} conversation={conversation} />
                ))}
              </div>
            </SidebarCollapsibleContent>
          </>
        )
      }

      {
        tracked
        && (
          <SidebarCollapsibleContent title="Filter By Resolution">
            <div role="group" aria-label="Filter by resolution">
              <ShowResolutionAuditsCheckbox />
            </div>
          </SidebarCollapsibleContent>
        )
      }
    </>
  )
}

export default AuditableFilters
